export enum ROUTES {
  HOME_ROUTE = '/home',
  PRODUCTS_ROUTE = '/products',
  CLIENTS_ROUTE = '/clients',
}
